export default __webpack_public_path__ + "static/img-ef-3-847265ec3d4dcc63021d011392a3d755.png";